import React, { useState, useEffect } from 'react';
import { useSelector } from "react-redux";
import { Space, Button } from "antd";
import { ExclamationCircleOutlined } from '@ant-design/icons';
import Cookies from 'js-cookie';
import { redirectToLogin } from "../../service/auth";
import './Login.scss';

const Login = () => {
    const [isLogin, setIsLogin] = useState(!!Cookies.get('access_token'));
    const login = useSelector((state: any) => state?.guard?.isLogin);

    useEffect(() => {
        setIsLogin(!!Cookies.get('access_token'))
    }, [])
    useEffect(() => {
        setIsLogin(!!Cookies.get('access_token'))
    }, [login])
    const startMtidLogin = () => {
        redirectToLogin();
    };

    return (
        <>
            {
                !isLogin ?
                    <div className='Login'>
                        <div className='iconBox'>
                            <ExclamationCircleOutlined className='icon' />
                            <span className='tipText'>账号未登录，登录账号后即体验全部功能。</span>
                        </div>
                        <div>
                            <Space>
                                <Button type='default' onClick={startMtidLogin}>注册</Button>
                                <Button type='primary' onClick={startMtidLogin}>登录</Button>
                            </Space>
                        </div>
                    </div>
                    : null
            }
        </>
    );
}

export default Login;
